import React from "react"
import CountUp from "react-countup"
import VisibilitySensor from "react-visibility-sensor"

export function StatContainer({ children, classes }) {
  return (
    <div className={classes ? `stat-container ${classes}` : `stat-container`}>
      {children}
    </div>
  )
}

export function Stat({
  prefix,
  suffix,
  number,
  unit,
  note,
  preamble,
  children,
  text,
  style,
}) {
  return (
    <div
      className={children ? "stat stat--icon" : "stat"}
      key={`stat${Math.random()}`}
      style={style ? style : null}
    >
      {children && <div className="stat__icon">{children}</div>}
      <div className="stat__text-section">
        {preamble && <div className="stat__note">{preamble}</div>}
        {text && <div className="stat__text">{text}</div>}

        {number && (
          <VisibilitySensor>
            {({ isVisible }) => (
              <CountUp
                end={number}
                duration={1.5}
                start={isVisible}
                delay={0}
                prefix={prefix}
                suffix={suffix}
                separator=","
              >
                {({ countUpRef }) => (
                  <div className="stat__number" ref={countUpRef} />
                )}
              </CountUp>
            )}
          </VisibilitySensor>
        )}

        {unit && <div className="stat__unit">{unit}</div>}
        {note && <div className="stat__note">{note}</div>}
      </div>
    </div>
  )
}
